import React, { useState, useEffect, useRef } from 'react';
import DesktopSelector from './DesktopSelector';
import SnapsWise from './SnapsWise';

const Audiobook = ({ subject, exerciseHandler }) => {
    console.log(subject, "exercise");
    const [transcripts, setTranscripts] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [currentScript, setCurrentScript] = useState(null);
    const [key, setKey] = useState(0);

    const getTranscripts = async (course) => {
        const token = localStorage.getItem("token");
        const outdata = {
            "owner": course.owner,
            "author": course.author,
            'title': course.title,
            'language': course.language,
            "type": course.type
        };
        
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/get-structure`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(outdata),
        });
        
        if (response.ok) {
            const json = await response.json();
            setTranscripts(json);
        }
    };

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            setCurrentScript(transcripts[activeTabIndex]);
            setKey(prev => prev + 1);
        }
    }, [activeTabIndex, transcripts]);
    
    useEffect(() => {
        if (subject) {
            getTranscripts(subject);
        }
    }, [subject]);

    useEffect(() => {
        if (transcripts && transcripts.length > 0) {
            const files = transcripts
                .filter(x => "file" in x)
                .map(x => x.file);
            setTabs(files);
        }
    }, [transcripts]);

    const hasMultipleParts = tabs && tabs.length > 1;

    return tabs && tabs.length > 0 && currentScript ? (
        <div className='h-screen w-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30 overflow-hidden flex flex-col relative'>
            {/* Compact Header with Middle Selector */}
            <div className='bg-gradient-to-r from-blue-500/90 to-indigo-600/90 backdrop-blur-sm w-full flex-shrink-0 border-b border-white/20 relative z-30'>
                {/* Desktop: All in one row */}
                <div className='hidden xl:flex items-center justify-between px-3 py-2'>
                    {/* Left: Back Button + Title/Author */}
                    <div className='flex items-center gap-2 flex-1 min-w-0'>
                        <button 
                                className="
                                flex items-center gap-2 text-white
                                px-3 py-2 rounded-xl
                                bg-white/15 hover:bg-white/25
                                border border-white/25
                                shadow-sm shadow-black/10
                                backdrop-blur
                                transition
                                focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
                                group
                                "                            
                                onClick={() => { exerciseHandler(null) }}      
                            title="Back to Library"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" 
                            className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            <span className='text-sm font-semibold tracking-wide'>Library</span>
                        </button>
                        
                        <div className='h-4 w-px bg-white/30'></div>
                        
                        <div className='min-w-0 truncate'>
                            
                            <h1 
                                className='font-semibold text-sm text-white truncate leading-none'
                                title={subject.title}
                            >
                                {subject.title}
                            </h1>
                            <p 
                                className='text-xs text-blue-100/80 truncate mt-0.5'
                                title={`by ${subject.author}`}
                            >
                                by {subject.author}
                            </p>
                        </div>
                    </div>
                    
                    {/* Middle: Desktop Selector with Tab Buttons */}
                    {hasMultipleParts && (
                        <div className='mx-4 flex-1 max-w-xl'>
                            <div className="flex justify-center">
                                <DesktopSelector 
                                    clickHandler={(tab_index) => {
                                        setActiveTabIndex(tab_index);
                                    }} 
                                    tabsData={tabs} 
                                    active={activeTabIndex}
                                />
                            </div>
                        </div>
                    )}
                    
                    {/* Right: Empty spacer for symmetry */}
                    <div className='flex-1 flex justify-end'>
                        <div className='w-8'></div>
                    </div>
                </div>
                
                {/* Mobile: Two rows */}
                <div className='xl:hidden px-3 py-2 relative'>
                    {/* Mobile Row 1: Back Button + Title + Basic Navigation */}
                    <div className='flex items-center justify-between gap-2'>
                        {/* Left: Back Button + Title/Author */}
                        <div className='flex items-center gap-2 flex-1 min-w-0'>
                            <button
  className="
    flex items-center gap-2
    text-white
    px-2.5 py-2
    rounded-xl
    bg-white/15 hover:bg-white/25
    border border-white/25
    shadow-sm shadow-black/10
    active:scale-[0.98]
    transition
    focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70
    group
    min-h-[44px]
    whitespace-nowrap
  "
  onClick={() => exerciseHandler(null)}
  title="Back to Library"
  aria-label="Back to Library"
  type="button"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 flex-shrink-0 group-hover:-translate-x-0.5 transition-transform"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>

  <span className="text-xs font-semibold leading-none">Back</span>
</button>

                            
                            <div className='min-w-0 truncate'>
                                <h1 
                                    className='font-semibold text-sm text-white truncate leading-none'
                                    title={subject.title}
                                >
                                    {subject.title}
                                </h1>
                                <p 
                                    className='text-xs text-blue-100/80 truncate mt-0.5'
                                    title={`by ${subject.author}`}
                                >
                                    by {subject.author}
                                </p>
                            </div>
                        </div>
                        
                        {/* Right: Mobile prev/next - Only show if multiple parts */}
                        {hasMultipleParts && (
                            <div className='flex items-center gap-1 flex-shrink-0'>
                                <button
                                    className="text-white hover:text-blue-100 p-1 hover:bg-white/20 rounded disabled:opacity-40 transition-colors"
                                    onClick={() => setActiveTabIndex(Math.max(0, activeTabIndex - 1))}
                                    disabled={activeTabIndex === 0}
                                    title="Previous part"
                                >
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                
                                <div className="text-white text-xs font-medium px-1.5 min-w-[3rem] text-center">
                                    {activeTabIndex + 1}/{tabs.length}
                                </div>
                                
                                <button
                                    className="text-white hover:text-blue-100 p-1 hover:bg-white/20 rounded disabled:opacity-40 transition-colors"
                                    onClick={() => setActiveTabIndex(Math.min(tabs.length - 1, activeTabIndex + 1))}
                                    disabled={activeTabIndex === tabs.length - 1}
                                    title="Next part"
                                >
                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>
                        )}
                    </div>
                    
                    {/* Mobile Row 2: Dropdown Selector - Only show if multiple parts */}
                    {hasMultipleParts && (
                        <div className="mt-2">
                            <MobileSelector 
                                tabsData={tabs}
                                activeTabIndex={activeTabIndex}
                                onSelectTab={setActiveTabIndex}
                            />
                        </div>
                    )}
                </div>
            </div>
            
            {/* Content Area */}
            <div className='flex-1 min-h-0 min-w-0 relative z-10'>
                <SnapsWise 
                    key={`${currentScript.file?.file}-${key}`} 
                    subject={subject} 
                    file={currentScript}
                />
            </div>
        </div>
    ) : (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-100/30">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 border border-white/40 shadow-lg">
                <div className="text-gray-600 text-lg">Loading your audiobook...</div>
            </div>
        </div>
    );
};

// Mobile Dropdown Selector Component with fixed positioning
const MobileSelector = ({ tabsData, activeTabIndex, onSelectTab }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);
    
    if (!tabsData || tabsData.length <= 1) return null;
    
    const handleSelect = (index) => {
        onSelectTab(index);
        setIsOpen(false);
    };
    
    return (
        <div className="relative w-full" ref={dropdownRef}>
            <button
                type="button"
                className="w-full flex items-center justify-between bg-white/80 backdrop-blur-sm text-gray-700 text-sm px-3 py-2 rounded-lg border border-white/40 hover:bg-white/90 transition-all relative z-20"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <div className="flex items-center gap-2">
                    <span className="font-medium">Select Part</span>
                    <span className="text-gray-500">({activeTabIndex + 1}/{tabsData.length})</span>
                </div>
                <svg 
                    className={`w-4 h-4 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            
            {isOpen && (
                <div className="absolute w-full mt-1 bg-white/95 backdrop-blur-md rounded-lg shadow-xl border border-white/40 py-2 max-h-60 overflow-y-auto z-50">
                    {tabsData.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            className={`w-full text-left px-4 py-2 text-sm hover:bg-blue-50/80 transition-colors flex items-center justify-between ${
                                idx === activeTabIndex 
                                    ? 'bg-blue-500/10 text-blue-700 font-medium' 
                                    : 'text-gray-700'
                            }`}
                            onClick={() => handleSelect(idx)}
                        >
                            <span>Part {idx + 1}</span>
                            {idx === activeTabIndex && (
                                <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                            )}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Audiobook;